import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  formatCurrency,
  formatDate,
  formatDateTime,
  formatDuration,
  formatNumber,
  formatPercent,
  formatCompact,
} from "./format";
import { isLanguage, DEFAULT_LANGUAGE, type Language } from "./setup";

/** Formatters bound to the active language. */
export function useFormat() {
  const { i18n } = useTranslation();
  const lang: Language = isLanguage(i18n.language) ? i18n.language : DEFAULT_LANGUAGE;
  return useMemo(
    () => ({
      lang,
      number: (v: number, o?: Intl.NumberFormatOptions) => formatNumber(v, lang, o),
      compact: (v: number) => formatCompact(v, lang),
      percent: (v: number, d?: number) => formatPercent(v, lang, d),
      currency: (v: number, c?: string) => formatCurrency(v, lang, c),
      date: (v: Date | string | number) => formatDate(v, lang),
      dateTime: (v: Date | string | number) => formatDateTime(v, lang),
      duration: (ms: number) => formatDuration(ms, lang),
    }),
    [lang],
  );
}
